export default "/images/framework/GrandBarEng.9c0b22c3.svg?9c0b22c3";